// extracted by mini-css-extract-plugin
export default {"triangleDown":"Pricing_triangleDown__D+OW1","Header":"Pricing_Header__EKPGC"};